import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./styles.css";

interface Tab {
  label: string;
  content: JSX.Element;
}

interface TabsProps {
  tabs: Tab[];
  parentLanguage: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, parentLanguage }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="tabs">
      <div className="tabs__nav">
        {tabs.map((tab, index) => (
          <NavLink
            key={index}
            className={`tabs__nav-item ${
              activeTab === index ? "tabs__nav-item--active" : ""
            }`}
            onClick={() => setActiveTab(index)}
            to={`/${parentLanguage}/${tab.label}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      {tabs[activeTab].content}
    </div>
  );
};

export default Tabs;
